import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
/* import { LanguageService } from '../language/language.service'; */

@Injectable()
export class HttpConfigService {
    // global variable from connections.js included in index.html
    // public readonly apiServerUrl: string = window['apiServerUrl'];
    public readonly apiServerUrl: string = environment.apiServerUrl;

    constructor(/* private languageService: LanguageService */) {

    }

    /* public buildUrl(controller: string, methodName: string, ...parameters: string[]): string {
        return this.apiServerUrl + 'api/' + controller + '/' + methodName + '?' + parameters.join('&');
    } */

    /* public buildReportUrl(reportName: ReportNames, ...parameters: string[]) {
        const lang: string = 'languageOrder=' + this.languageService.getAcceptLanguageHeader();
        parameters.push(lang);
        return this.buildUrl('reports', ReportNames[reportName], ...parameters);
    } */
}
